/**
 * Тур по странице прицепов.
 * Знакомит пользователя с управлением прицепами.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'trailers-page',
  name: 'help.tours.trailers.name',
  description: 'help.tours.trailers.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Заголовок и кнопка добавления
    {
      element: '.page-toolbar',
      titleKey: 'help.tours.trailers.toolbar.title',
      descriptionKey: 'help.tours.trailers.toolbar.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 2: Статистика прицепов
    {
      element: '.stats-row',
      titleKey: 'help.tours.trailers.stats.title',
      descriptionKey: 'help.tours.trailers.stats.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 3: Поиск
    {
      element: '.search-bar',
      titleKey: 'help.tours.trailers.search.title',
      descriptionKey: 'help.tours.trailers.search.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 4: Сетка карточек прицепов
    {
      element: '.trailers-grid',
      titleKey: 'help.tours.trailers.grid.title',
      descriptionKey: 'help.tours.trailers.grid.description',
      side: 'top',
      align: 'center',
    },
    // Шаг 5: Карточка прицепа
    {
      element: '.trailer-card',
      titleKey: 'help.tours.trailers.card.title',
      descriptionKey: 'help.tours.trailers.card.description',
      side: 'left',
      align: 'center',
    },
    // Шаг 6: Характеристики прицепа
    {
      element: '.trailer-card__specs',
      titleKey: 'help.tours.trailers.specs.title',
      descriptionKey: 'help.tours.trailers.specs.description',
      side: 'bottom',
      align: 'center',
    },
  ],
}
